var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"uc"},[_c('CodeSnippetLoader',{attrs:{"filePath":`/snippets/${_vm.$i18n.locale}/${_vm.fileName}.html`},on:{"clickBuy":_vm.clickBuy}}),_c('ScenesView',{staticClass:"bg-[#f0f2f8]"}),_c('SolutionsView',{on:{"clickBuy":_vm.clickBuy,"clickCustomService":_vm.clickCustomService}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }